import { render, staticRenderFns } from "./sales_vital.vue?vue&type=template&id=1813a707&scoped=true&"
import script from "./sales_vital.vue?vue&type=script&lang=js&"
export * from "./sales_vital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1813a707",
  null
  
)

export default component.exports